/*
 * Copyright (C) 2021 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { onlyDigits } from './onlyDigits';

/**
 * Standardize phone number to use E.164 format
 * @param phone - {string}
 */
const formatPhoneNumber = (phone?: string | null) => {
  const phoneValue = phone ?? '';

  if (/^\+[1-9]\d{1,14}$/.test(phoneValue)) {
    return phoneValue;
  }

  const e164Format = `+${onlyDigits(phoneValue)}`;

  if (/^\+[1-9]\d{1,14}$/.test(e164Format)) {
    return e164Format;
  }

  return null;
};

export { formatPhoneNumber };
